import { render } from "./ow-clients-categories.vue?vue&type=template&id=33c4a085"
import script from "./ow-clients-categories.vue?vue&type=script&lang=js"
export * from "./ow-clients-categories.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__